import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/admissionProcess.js";

const steps = [
  {
    number: 1,
    title: "Free Consultation",
    desc: "Tell Us Your Goals and Budget",
  },
  {
    number: 2,
    title: "University Shortlist",
    desc: "5–8 Matched Universities",
  },
  {
    number: 3,
    title: "Application Prep",
    desc: "SOP, Docs, Submissions",
  },
  {
    number: 4,
    title: "Offer & Acceptance",
    desc: "Compare and Confirm",
  },
  {
    number: 5,
    title: "Visa Application",
    desc: "Full Visa Guidance",
  },
  {
    number: 6,
    title: "Pre-departure",
    desc: "Housing, Banking, Travel",
  },
];

function AdmissionProcess() {
  return (
    <Styles>
      <section className="admission-process">
        <Container>
          <Row>
            <Col md="12">
              <div className="sec-title text-center">
                <h4>Admission Process</h4>
                <h3>Your Journey to Studying Abroad</h3>
                <p>From your first call to your first day on campus</p>
              </div>
            </Col>
            <Col md="12">
              <div className="process-wrap">
                <Row>
                  {steps.map((step) => (
                    <Col lg="4" md="6" key={step.number} className="process-col">
                      <div className="process-card">
                        <span className="step-number">{step.number}</span>
                        <h5>{step.title}</h5>
                        <p style={{fontWeight:"600", fontSize:15}}>{step.desc}</p>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
}

export default AdmissionProcess;
